module.exports = __webpack_public_path__ + "static/media/parrot.48885603.png";